import Alert from 'react-bootstrap/Alert';
import { useEffect } from 'react';

const OrgConstraintAlert = ({
  initialConstraintsState, organizationDisplayName, orgPolicyConstraintSet, result, setCurrentStepResult, setInitialConstraintsState,
}) => {
  useEffect(() => {
    if (!initialConstraintsState && orgPolicyConstraintSet) {
      setInitialConstraintsState(true);
      setCurrentStepResult({
        roles: {},
        constraints: { ...result.constraints, orgPolicyError: orgPolicyConstraintSet },
      });
    }
  }, [initialConstraintsState, orgPolicyConstraintSet, result, setCurrentStepResult, setInitialConstraintsState]);

  if (!orgPolicyConstraintSet) return null;

  return (
    <Alert className="content-alert" variant="warning">
      <p className="mt-2"><strong>Notice - Organization Policy Error</strong></p>
      <p>
        An organization policy on
        {' '}
        <strong>{ organizationDisplayName }</strong>
        {' '}
        prevents granting the Rackspace automation service account
        access to the organization.
      </p>
      <p>
        This will impact our ability to service your account and will entirely prevent Rackers from accessing your projects in future.
      </p>
      <p>
        Please work with your Administrator to modify the policy to allow gcp.rackspace.com domain ID:
        {' '}
        <strong>C01maxa7I</strong>
      </p>
    </Alert>
  );
};

export default OrgConstraintAlert;
